export const createExcalidrawNodeSpec = () => ({
    marks: "",
    group: "block",
    atom: true,
    isolating: true,
    attrs: {
        width: { default: null },
        height: { default: null },
        data: { default: null },
        textAlign: { default: null },
        createdAt: { default: null },
        updatedAt: { default: null },
    },
    draggable: false,
    selectable: true,
    toDOM: (node) => {
        return [
            "span",
            {
                "data-ss-excalidraw": "true",
                "data-width": node.attrs.width,
                "data-height": node.attrs.height,
                "data-excalidraw-graph": node.attrs.data,
                "data-text-align": node.attrs.textAlign || "left",
                "data-created-at": node.attrs.createdAt,
                "data-updated-at": node.attrs.updatedAt,
            },
        ];
    },
    parseDOM: [
        {
            tag: "span[data-ss-excalidraw]",
            getAttrs: (dom) => {
                const domElement = dom;
                return {
                    width: domElement.getAttribute("data-width"),
                    height: domElement.getAttribute("data-height"),
                    data: domElement.getAttribute("data-excalidraw-graph"),
                    textAlign: domElement.getAttribute("data-text-align"),
                    createdAt: domElement.getAttribute("data-created-at"),
                    updatedAt: domElement.getAttribute("data-updated-at"),
                };
            },
        },
    ],
});
export const excalidrawNodesSpec = () => ({
    excalidraw: createExcalidrawNodeSpec(),
});
